window.addEventListener('DOMContentLoaded', (event) => {
	const resource = document.querySelectorAll(
		'.wp-block-vs-resource .wp-block-file a'
	);

	if (resource) {
		resource.forEach((file) => {
			file.setAttribute('download', '');
		});
	}
});
